/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 29.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ClassNames from 'classnames';

import Translate from '../../../components/Translate';
import DivLoader from '../../../components/DivLoader';

import {LogOut, ForgottenPasswordChange} from '../../../actions/auth/actions-auth';

class ResetPasswordTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formDataNewPassword: '',
      formDataAck: ''
    };
  }

  componentWillMount() {

    this.props.LogOut();
  }

  componentDidMount() {

    this.setState({formDataAck: this.props.ack});

    document.getElementById('resetPassword') && document.getElementById('resetPassword').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', function () {

      document.getElementById('resetPassword') && document.getElementById('resetPassword').focus();
    });
  }

  componentWillReceiveProps(newProps) {

    if (!newProps.inProgress && newProps.isError) {

      setTimeout(() => {

        document.getElementById('resetPassword') && document.getElementById('resetPassword').focus();
      }, 350);
    }

    if (!newProps.inProgress && newProps.isSuccess) {

      window.location.hash = '';
    }
  }

  _onChangeNewPassword(event) {

    this.setState({
      formDataNewPassword: event.target.value
    });
  }

  _onChangeAck(event) {

    this.setState({
      formDataAck: event.target.value
    });
  }

  _onSubmit(event) {
    event.preventDefault && event.preventDefault();

    this.props.ForgottenPasswordChange(this.state.formDataAck, this.state.formDataNewPassword);
  }

  _isPasswordResetDone() {

    return !this.props.inProgress && this.props.isSuccess;
  }

  render() {

    const newPassClasses = ClassNames({
      'auth-field enter-auth-submit': true,
      'error-field': this.props.isError && (this.props.errorMsg === 'password field empty' || this.props.errorMsg === 'password too short')
    });

    const ackClasses = ClassNames({
      'auth-field enter-auth-submit': true,
      'error-field': this.props.isError && this.props.errorMsg === 'invalid password reset code'
    });

    if (this.props.isSuccess) {

      return (<h2 style={{margin: '2% 0 2%'}}><Translate content="settings.tabs.reset_password.success" /></h2>);
    }

    if (this._isPasswordResetDone()) {
      return (
        <div className="settings-col">
          <h2 style={{margin: '2% 0 2%'}}><Translate content="settings.tabs.reset_password.success" /></h2>
        </div>);
    }

    return (
      <div>
        <DivLoader loading={this.props.inProgress} />
        <h2 style={{margin: '2% 0 2%'}}><Translate content="settings.tabs.reset_password.enter_new_password" /></h2>
        <form id="regForm" className="js-form" role="form" onSubmit={this._onSubmit.bind(this)}>
          <div className="settings-col">
            <label htmlFor="resetPassword"><Translate content="settings.tabs.reset_password.password" /></label>
            <input id="resetPassword" name="resetPassword" type="password" className={newPassClasses} value={this.state.formDataNewPassword} onChange={this._onChangeNewPassword.bind(this)} tabIndex="1" />
            {!this.props.ack && <div>
              <label htmlFor="resetAck"><Translate content="settings.tabs.reset_password.ack" /></label>
              <input id="resetAck" name="resetAck" type="text" className={ackClasses} value={this.state.formDataAck} onChange={this._onChangeAck.bind(this)}
                     tabIndex="2" />
            </div>}
            <a className="btn-dark authorization" href="javascript:void(0)" onClick={this._onSubmit.bind(this)}>
              <Translate content="settings.tabs.change_password.save" /> </a>
            <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="3" />
            <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="4">Submit</button>
          </div>
        </form>
        {this.props.isError && <div className="reg-error-message" style={{position: 'absolute', top: '15px', right: '50px'}}>
          <em> <Translate content={`error.${this.props.errorMsg}`} /> </em>
        </div>
        }
      </div>
    );
  }
}

ResetPasswordTab.propTypes = {
  inProgress: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
  ack: PropTypes.string
};

const mapStateToProps = ({auth: {reset: {isSuccess, isError, errorMsg, inProgress}}}) => {

  return {isSuccess, isError, errorMsg, inProgress};
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({LogOut, ForgottenPasswordChange}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/reset-password.js